import { gql } from '@apollo/client';

export const WORK_STATUS_SUBSCRIPTION = gql`
  subscription($userId: ID!) {
    checkInStatus(userId: $userId)
  }
`;
